<template>
  <div class="join-us">
    <!-- <div class="join-img">
      <img src="../images/1.jpg" alt="">
    </div> -->
    <div style="width:100%;height:20px;background:#efefef"></div>
   <div class="p">
       <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{path:'/productCenter'}">产品中心</el-breadcrumb-item>
          <el-breadcrumb-item v-if="onelevel !== ''">{{onelevel}}</el-breadcrumb-item>
          <el-breadcrumb-item v-if="twolevel !== ''">{{twolevel}}</el-breadcrumb-item>
          <el-breadcrumb-item v-if="threelevel !== ''">{{threelevel}}</el-breadcrumb-item>
          <el-breadcrumb-item v-if="fourlevel !== ''">{{fourlevel}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class='join-main'>
      <div class="left">
        <leftBox :category_path_id="category_path_id"></leftBox>
      </div>
         <div class="main-right-talented">
          <detailright :id="id" :detailData="detailData"></detailright>
        </div>
    </div>
    <div class="rightfixed">
        <ul :class="searchBarFixed == true ? 'isFixed' :''">
           <rightFixed></rightFixed>
        </ul>
    </div>
   <Bottom></Bottom>
  </div>
</template>

<script>
import Bottom from '../../../components/bottom'
import leftBox from "../../searchData/components/leftBox"
import detailright from '../components/detailright'
import rightFixed from "../../productCenter/components/rightFixed"
import {mapState, mapActions, mapMutations} from "vuex"
export default {
  name: 'join-us',
  data () {
    return {
      searchBarFixed: false,
      offsetTop: 0,
      id:this.$route.query.id,
      onelevel:'',
      twolevel:'',
      threelevel:'',
      fourlevel:'',
      category_path_id:'',
      detailData:[]
    }
  },
  components:{
    Bottom,
    leftBox,
    rightFixed,
    detailright
  },
  mounted () {
     window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
      handleScroll () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        var offsetTop = document.querySelector('.rightfixed').offsetTop
        if (scrollTop > offsetTop) {
          this.searchBarFixed = true
        } else {
          this.searchBarFixed = false
        }
      },
      getId(type,id){
        this.$api.productCenter
          .getproduct({
            rank: type
          })
          .then(res => {
            res.data.length > 0 && res.data.forEach(item=>{
              if(id[0] == item.id){
                 this.onelevel = item.name
                 item.children && item.children.forEach(ite=>{
                  if(id[1] == ite.id){
                    this.twolevel = ite.name
                    ite.children && ite.children.forEach(it=>{
                      if(id[2] == it.id){
                        this.threelevel = it.name
                        it.children && it.children.forEach(i=>{
                          if(id[3] == i.id){
                            this.fourlevel = i.name
                          }
                        })
                      }
                    })
                  }
                })
              }
          })
        })
      }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },  
  created() {
     this.$api.productCenter
      .goodsDetail({
        goods_code: this.id
      })
      .then(res => {
        const arr = res.data.sku;
        arr.forEach(item => {
          item.num = 1;
        });
        this.detailData = res.data;
        var a = res.data.category_path_id
        var b = a.split(',')
        this.category_path_id = a
        this.getId(0,b)
      })
  },
}
</script>

<style lang="less" scoped>
.join-us{
  width: 1920px;
  background: #efefef;
  box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5); 
  position: relative;
  .rightfixed{
      width: 90px;
      height:230px;
      position: absolute;
      top:550px;
      right:10px;
      .isFixed{
        position:fixed;
        bottom:150px;
        z-index:999;
      }
  }
  .box-one{
      width: 1510px;
      height: 316px;
      background: #f6f6f6;
      margin: auto;
      background: url("../../../images/four.png");
  }
  .p{
    font-size: 14px;
    margin: 0px 0px 20px 300px;;
    color: #666666;
    line-height: 19px;
     /deep/.el-breadcrumb__inner.is-link{
      color:#666666
    }
  }
  .join-main{
    width: 1510px;
    background: #ffffff;
    margin: auto;
    margin-bottom: 20px;;
    display: flex;
    .left{
      margin-left: 65px;
    }
    .main-right-talented{
      width: 876px;
      background: #ffffff;
      margin-top: 44px;;
      margin-left: 61px;;
    }
    .main-right-argent{
      width: 876px;
      background: #ffffff;
      margin-top: 80px;;
    }
  }
  .join-img{
    width: 100%;
    img{
      width: 1920px;
      height: 300px;
    }
  }
  .five{
    width: 805px;
    height: 49px;
    margin: auto;
    margin-top: 15px;;
    font-size: 14px;
    text-align: center;
    color: #666666;
    line-height: 24px;
    span{
      font-size: 14px;
      text-align: center;
      color: #666666;
      line-height: 24px;
    }
  }
}
</style>